import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { supabase } from '../../Supabase/SupabaseClient'; // Ajusta la ruta según tu estructura
import './auth.css'; // Asegúrate de importar los estilos
import Footer from "../../Components/Footer/Footer";

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const { data, error: loginError } = await supabase.auth.signInWithPassword({
                email,
                password
            });

            if (loginError) throw loginError;

            console.log("Usuario autenticado:", data);
            navigate('/'); // Redirigir al dashboard
        } catch (err) {
            console.error("Error de inicio de sesión:", err.message);
            setError(err.message);
        }
    };

    const handleGoogleLogin = async () => {
        setError('');

        try {
            const { error: oauthError } = await supabase.auth.signInWithOAuth({
                provider: 'google',
                options: {
                    redirectTo: window.location.origin + '/', // Redirige después del login
                    queryParams: {
                        prompt: 'select_account' // Esto fuerza la selección de cuenta en Google
                    }
                }
            });

            if (oauthError) throw oauthError;
        } catch (err) {
            console.error("Error en login con Google:", err.message);
            setError(err.message);
        }
    };

    return (
        <>
        <div className="auth-container">
            <div className="auth-form-wrapper">
                <h2 className="auth-form-title">Iniciar Sesión</h2>
                
                {error && <div className="auth-error-message">{error}</div>}
                
                <form onSubmit={handleLogin} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">Correo Electrónico</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                className="form-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(prev => !prev)}
                                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                aria-pressed={showPassword}
                            >
                                {showPassword ? <EyeOff className="password-toggle-icon" /> : <Eye className="password-toggle-icon" />}
                            </button>
                        </div>
                    </div>
                    
                    <button type="submit" className="auth-submit-btn">
                        Iniciar Sesión
                    </button>
                </form>

                <button onClick={handleGoogleLogin} className="auth-google-btn">
                    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                        <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
                        <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
                        <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
                        <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
                    </svg>
                    Iniciar sesión con Google
                </button>
                
                <div className="auth-switch-text">
                    ¿No tienes cuenta?
                    <Link to="/registro" className="auth-switch-link">
                        Regístrate
                    </Link>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
}

export default Login;